const MUTATING_METHODS = ['post', 'put', 'patch', 'delete'];

/**
 * Whether a finished API call should refresh every cached query: any write of the customer app. Console writes
 * (`/v1/platform/...`) never touch customer data, and the impersonation stop in particular closes the very session the
 * mounted customer queries still use, so refetching them would only send a burst of calls that are answered 401.
 */
export function invalidatesQueries(config: { method?: string; url?: string }): boolean {
  const method = config.method?.toLowerCase();
  if (!method || !MUTATING_METHODS.includes(method)) return false;
  if (config.url?.includes('/v1/platform/')) return false;
  // A feedback note changes nothing the screens show: sending one must not refetch every query on the page.
  if (/\/v1\/feedback\/?(\?|$)/.test(config.url ?? '')) return false;
  // The owner's answer to an OAuth consent request (/oauth/requests/<id>/decision) spends the request: refetching it would only get `request_used` and
  // replace the "connected" screen. The consent page refreshes everything else itself (see ConsentPage).
  return !/\/oauth\/requests\/[^/]+\/decision\/?(\?|$)/.test(config.url ?? '');
}
